import React, {useState} from "react";
import {Button, Form, Grid, Header, Message, Segment} from 'semantic-ui-react'
import '../Login/Login.css'
import {useAuth} from "../../../lib/auth/useAuth";
import mustardBg from '../../../img/mustarddreams.png'
import MenuTopBar from "../../../components/Menu/MenuTopBar";
import { Link } from "react-router-dom";

function ForgotPassword(props) {
  let [email, setEmail] = useState("");  // identifier: username, email, or phone
  let [sent, setSent] = useState(false);
  let [error, setError] = useState(null);
  let [loading, setLoading] = useState(false);
  let auth = useAuth()
  return (
    <div id={'login-page'}>
      <div id="dashboard">
        <MenuTopBar />
      </div>
      <img alt="" style={{ minWidth: '600px', width: '100%', height: '100%', position: 'absolute', left: '0', top: '20px' }} src={mustardBg} />
      <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
        <Grid.Column style={{maxWidth: 450}}>
          <Header as='h2' className={'white-text'} textAlign='center'>
          </Header>
          <Form size='large' className={'login-form'} onSubmit={ async () =>  {
            setError(null);
            setLoading(true);
            let res = await auth.sendPasswordResetEmail(email);
            setLoading(false);
            if (res.success) {
              setSent(true);
            } else {
              setError(res.error);
            }
          }}>
            <Segment basic stacked className={'login-form'}>
              {sent ? (
                <Message
                  positive
                  visible
                  header='Check your phone'
                  content={`If an account matches "${email}", we just texted a reset link to the phone on file.`}
                />
              ) : (
                <>
                  <Form.Input
                    fluid
                    icon='user'
                    iconPosition='left'
                    placeholder='Username, email, or phone'
                    name="identifier"
                    type="text"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                  <Message
                    error
                    visible={!!error}
                    header='Could not send reset link'
                    content={error}
                  />
                  <Button className={'login-btn'} color='blue' fluid size='large' type='submit' loading={loading} disabled={!email || loading}>
                    Text Me a Reset Link
                  </Button>
                </>
              )}
            </Segment>
          </Form>
          <Message>
            Remembered it? <Link to="/login">Log In</Link>
          </Message>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default ForgotPassword;
